import { InjectionToken } from '@angular/core';

export const EVERNORTH_MEMBER_APOLLO_CONFIG =
  new InjectionToken<EvernorthMemberApolloConfig>(
    'EVERNORTH_MEMBER_APOLLO_CONFIG',
  );

export interface EvernorthMemberApolloConfig {
  graphQLUri: string;
  awsGraphQLUri: string;
}
